<template>
  <div>
    <row v-for="(item,i) in name" :name="item" :data="that[`config${i+1}`].arr" :teamIndex.sync="that[`config${i+1}`].index"
         :key="'areacodeList'+i"
         v-if="i==0||(that[`config${i}`].index&&that[`config${i+1}`].arr.length>1)"></row>
  </div>
</template>

<script>
  import {apiResignAll} from "@/api/apiResignAll"
	export default {
		name: "areacodeList",
    components: {
      row: () => import("./row"),
    },
		data() {
			return {
			  name:['省份','所在地'],
        that:this,
        config1:{
          arr:[],
          index:''
        },
        config2:{
          arr:[],
          index:''
        },
			}
		},
		watch: {},
		created() {
			this.getArea()
		},
		methods: {
      /** @name 获取省份 */
      getArea() {
        if(!this.$store.state.HC_areacodeList){
          apiResignAll.getLocation().then(res => {
            if (res && res.data && res.data.code === 200) {
              this.createdata(res.data.data.data,1);
              this.$store.state.HC_areacodeList=res.data.data.data;
            }
          })
        }else{
          this.createdata(this.$store.state.HC_areacodeList,1);
        }
      },
      createdata(data,type){
        if(type>2)return;
			  this[`config${type}`].arr=[
          {
            children: [],
            grade: 1,
            name: "全国",
            no: "",
            parentNo: "0"
          },
          ...data
        ]
        while(type<3){
          this[`config${type}`].index='';
          type++;
        }
      },
			/** @name 搜索单项 */
			send(name) {
			  let arr=[];
			  let index=this.name.indexOf(name)+1;
        if(index<6){
          let data=this[`config${index}`].arr[this[`config${index}`].index].children;
          if(!data)data=[];
          this.createdata(data,index+1)
        }
			  for(let i=1;i<index+1;i++){
			    if(this[`config${i}`].index!==''){
            arr.push(this[`config${i}`].arr[this[`config${i}`].index])
          }
        }
				//添加搜索项
				this.$parent.$refs.screen.areacodeList=arr;
			},
			/** @name 清队单项 */
			close(item) {
        item++;
        while(item<3){
          this[`config${item}`].index='';
          item++;
        }
			},
			/** @name 清空所有 */
			closeall() {
				this.config1.index = ''
			}
		},
	}
</script>

<style scoped>
/deep/.menu_box:last-child{
  border-bottom: 1px solid #e4e7ed;
}
</style>
